import React, { PropsWithChildren } from "react";
import styled from "styled-components";
import { getNewLookTokens } from "common/NewLook/tokens.ts";

interface StatusDotProps {
  /** The status colour (a theme token); the label stays in text colour. */
  color: string;
  className?: string;
}

/**
 * New look: a quiet status - a small still dot in the status colour and the
 * label in the text colour (no halo, no tinted chip).
 */
const StatusDot = ({
  color,
  className,
  children,
}: PropsWithChildren<StatusDotProps>) => (
  <Wrapper className={className}>
    <Dot style={{ background: color }} aria-hidden={true} />
    {children}
  </Wrapper>
);

export default StatusDot;

const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: ${(p) => getNewLookTokens(p.theme).text};
  font-size: 13.5px;
  line-height: 20px;
  white-space: nowrap;
`;
const Dot = styled.span`
  flex: none;
  width: 7px;
  height: 7px;
  border-radius: 50%;
`;
